import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sports-service',
  templateUrl: './sports-service.component.html',
  styleUrls: ['./sports-service.component.scss']
})
export class SportsServiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
